import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LogoLoaderComponent } from './logo-loader.component';

@NgModule({
  imports: [CommonModule],
  declarations: [LogoLoaderComponent],
  exports: [LogoLoaderComponent],
})
export class LogoLoaderModule {}
